export enum Common {
  TITLE = 'Opinico',
  JWT_TOKEN = 'jwt',
  i18n_KEY = 'i18next.translate.boo',
}
